import React from 'react';
import { Redirect, Route, Switch } from "react-router";
import { AddEdit } from "./AddEdit";
import { ListT } from "./List";

function Usuarios({ match }) {
    const { path } = match

    return (
        <Switch>
            <Route exact path={path} component={ListT} />
            <Route path={`${path}/add`} component={AddEdit} />
            <Route path={`${path}/edit/:id`} component={AddEdit} />
            <Redirect from="*" to={{
                                pathname: ListT
                            }}/>
        </Switch>
    ); 
}


export { Usuarios };